export default "__VITE_ASSET__CUcT0L3y__"